export const EVENT_BUS = {
  RESET_TAB_DIRTY: 'ResetTabDirty',
  TABS_LOADED: 'tabs-loaded',
  VERTICAL_TABS_LOADED: 'vertical-tabs-loaded',
  HORIZONTAL_TABS_LOADED: 'horizontal-tabs-loaded',
  PROCESS_JOB: 'process-job',
  DOCUMENT_HISTORY_LOG_UPDATED: 'document-history-log-updated',
  DOCUMENT_VERSION_CHANGED: 'document-version-changed'
};
